























































import { Vue, Component } from "vue-property-decorator";
import * as user from "../../_store/user.module";
import * as auth from "../../_store/auth.module";
import * as data from "../../_store/data.module";
import { bus } from "../../main";
import { userUtils } from "../../_utils/userUtils";
import CardTitle from "../../components/CardTitle.vue";
import { router } from "../../_router";
import { EnterpriseInfo } from "../../_models/enterpriseInfo";
import { DocList } from "../../_models/docList";
import { UserInfo } from "../../_models/userInfo";
import Ispezione from "../../components/Ispezione.vue"

@Component({
	components: {
		CardTitle,
		Ispezione
	}
})
export default class Modules extends Vue {
	private titleParams: object;
	private docBlock: DocList[];
	private ispezione: any;
	// private userDoc: any[]

	constructor() {
		super();
		this.titleParams = {
			title: "Moduli",
			cols: "12",
			sm: "5",
			md: "5",
			lg: "4"
		};
		this.docBlock = [];
		this.ispezione = null
		// this.userDoc = []
	}

	toRespDatiModule(idIstituto: number, idDoc: any) {
		var enterpriseInfo = user.readEnterpriseInfo(this["$store"]);
		var checkCompleteInfo = userUtils.checkEnterpriseInfo(enterpriseInfo);
		if (checkCompleteInfo) {
			var id = String(idIstituto);
			router.push({
				name: "nominaResponsabile",
				params: {
					idIstituto: id,
					idDoc: idDoc
				}
			});
		} else {
			bus.$emit("incompleteInfo");
		}
	}

	toReviewRespDatiModule(idDoc: any, idStatoDoc: any) {
		var userInfo = user.readUserInfo(this["$store"]);
		var ruoloUtente: any = userInfo.ruoloUtente;
		router.push({
			name: "review",
			params: {
				docType: "nominaResponsabile",
				idDoc: idDoc,
				idStatoDoc: idStatoDoc,
				ruoloUtente: ruoloUtente
			}
		});
	}

	loadIspezione(idAzienda: number) {
		var payload = {
			idAzienda: idAzienda,
			idIstituto: 1
		}

		data.dispatchIspezioneAzienda(this["$store"], payload)
			.then(response => {
				if (response.idIspezione !== undefined) {
					this.ispezione = response
				} else {
					this.ispezione = null
				}
			})
			.catch(error => {
				if (error.response.status === 401) {
					bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
					this["$router"].push("/login");
				} else {
					bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
				}
			});
	}

	loadModules(idAzienda: number) {
		var payload = {
			idAzienda: idAzienda,
			idIstituto: 0
		};
		// var docBlock: DocList = {
		//   idIstituto: 0,
		//   userDocs: []
		// };
		data
			.dispatchCollaborationInstitutes(this["$store"], idAzienda)
			.then(response => {
				response.forEach(element => {
					let idIst = element.IdIstituto;
					payload.idIstituto = element.IdIstituto;
					data
						.dispatchEnterpriseDoc(this["$store"], payload)
						.then(resp => {
							// docBlock = {
							//   idIstituto: idIst,
							//   userDocs: resp
							// };
							// this.docBlock.push(docBlock);

							this.docBlock.push({
								idIstituto: idIst,
								userDocs: resp
							});
							// docBlock = {
							//   idIstituto: 0,
							//   userDocs: []
							// };
						})
						.catch(error => {
							if (error.response.status === 401) {
								bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
								this["$router"].push("/login");
							} else {
								bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
							}
						});
				});
			})
			.catch(error => {
				if (error.response.status === 401) {
					bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
					this["$router"].push("/login");
				} else {
					bus.$emit("errorOperation", (error.response && error.response.data) || error.message || 'Errore del server');
				}
			});
	}

	created() {
		var token = localStorage.getItem("userToken");
		var enterpriseInfo: EnterpriseInfo;
		var userInfo: UserInfo;
		var parsedToken: any;
		if (token !== null) {
			parsedToken = userUtils.parseToken(token);
		}
		var payload = {
			idUtente: parsedToken.IdUtente,
			tipoSoggetto: parsedToken.IdTipoSoggetto,
			username: parsedToken.Username
		};
		user
			.dispatchSetUserInfo(this["$store"], payload)
			.then(() => {
				user
					.dispatchSetEnterpriseInfo(this["$store"])
					.then(() => {
						userInfo = user.readUserInfo(this["$store"]);
						bus.$emit("loadMenu");
						enterpriseInfo = user.readEnterpriseInfo(this["$store"]);
						// if(userInfo.ruoloUtente !== 2){
						this.loadModules(enterpriseInfo.idAzienda);
						this.loadIspezione(enterpriseInfo.idAzienda)
						// }
					})
					.catch(() => {
						bus.$emit("stopLoading");
						auth.dispatchLogout(this["$store"]);
						user.dispatchClearState(this["$store"]);
						this["$router"].push("/sessionExpired");
					});
			})
			.catch(() => {
				bus.$emit("stopLoading");
				auth.dispatchLogout(this["$store"]);
				user.dispatchClearState(this["$store"]);
				this["$router"].push("/sessionExpired");
			});

		bus.$on("loadIspezione", () => {
			var enterpriseInfo = user.readEnterpriseInfo(this["$store"]);
			this.loadIspezione(enterpriseInfo.idAzienda)
		});
	}
}
